import {Injectable} from '@angular/core';
import {AbstractDataServiceDtoSummaryAdapter} from "../../../../../../core/service/v2/dataservice/adapter/abstractDataServiceDtoSummaryAdapter";
import {PaymentRequestReminderModel} from "../../api/entity/paymentRequestReminder.model";
import {PaymentRequestReminderSummaryModel} from "../../api/entity/paymentRequestReminderSummary.model";
import {PaymentRequestReminderSummaryConverter} from "../../api/entity/converter/paymentRequestReminderSummary.converter";
import {PaymentRequestReminderDataService} from "./paymentRequestReminderData.service";


@Injectable()
export class PaymentRequestReminderSummaryDataServiceAdapter extends AbstractDataServiceDtoSummaryAdapter<PaymentRequestReminderSummaryModel, PaymentRequestReminderSummaryConverter, PaymentRequestReminderModel> {
    constructor(dataService: PaymentRequestReminderDataService, converter: PaymentRequestReminderSummaryConverter) {
        super(dataService, converter);
    }

    newStoredEntityInstance(): PaymentRequestReminderModel {
        return new PaymentRequestReminderModel();
    }


}
